import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import about_company from '@/components/about_company'
import about_media from '@/components/about_media'
import cooperation from '@/components/cooperation'
import recruitment from '@/components/recruitment'
import experience from '@/components/experience'
import media_content from '@/components/media_content'
import privacy from '@/components/privacy'
import privacy_ydd from '@/components/privacy_ydd'
import terms from '@/components/terms'
import terms_ydd from '@/components/terms_ydd'
import icp from '@/components/icp'
import privacyNt from '@/components/privacy_nt'
import termsNt from '@/components/terms_nt'
import cpInfo from '@/components/cp_info.vue'
import privacy_vivo from '@/components/privacy_vivo.vue'
import privacy_gzxb_wqdzl from '@/components/privacy_gzxb_wqdzl.vue'

import privacy_gzxb from '@/components/privacy_gzxb.vue'

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', name: 'home', component: index },
    { path: '/index', name: 'index', component: index },
    {
      path: '/about',
      name: 'about',
      component: about,
      children: [
        {
          path: '',
          name: 'about_home',
          component: about_company
        },
        {
          path: 'company',
          name: 'company',
          component: about_company
        },
        {
          path: 'media',
          name: 'media',
          component: about_media
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: cooperation,
          redirect: '/cooperation'
        },
        {
          path: 'mediaContent',
          name: 'mediaContent',
          component: media_content
        }
      ]
    },
    { path: '/experience', component: experience },
    { path: '/recruitment', component: recruitment },
    { path: '/cooperation', name: 'cooperation', component: cooperation },
    { path: '/privacy', name: 'privacy', component: privacy },
    { path: '/terms', name: 'terms', component: terms },
    { path: '/privacy_ydd', name: 'privacy_ydd', component: privacy_ydd },
    { path: '/terms_ydd', name: 'terms_ydd', component: terms_ydd },
    { path: '/icp', name: 'icp', component: icp },
    { path: '/privacy_nt', name: 'privacy_nt', component: privacyNt },
    { path: '/terms_nt', name: 'terms_nt', component: termsNt },
    { path: '/cp_info', name: 'cp_info', component: cpInfo },
    { path: '/privacy_vivo', name: 'privacy_vivo', component: privacy_vivo },
    { path: '/privacy_gzxb_wqdzl', name: 'privacy_gzxb_wqdzl', component: privacy_gzxb_wqdzl },
    { path: '/privacy_gzxb', name: 'privacy_gzxb', component: privacy_gzxb  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js